<h2 mat-dialog-title tabindex="0" class="narrow" data-test-id="create-aufgabe-dialog-title">
	Aufgabe in Verfügung vom {{ verfuegung.createdAt | formatDate }}
</h2>
<form [formGroup]="form">
	<div mat-dialog-content data-test-id="create-aufgabe-dialog-content">
		<mat-form-field appearance="outline">
			<mat-label>Aufgabentyp</mat-label>
			<mat-select cdkFocusInitial data-test-id="select-aufgaben-typ" [formControl]="form.controls.typ">
				@for (aufgabenTyp of validAufgabenTypen; track aufgabenTyp) {
					<mat-option [value]="aufgabenTyp" data-test-id="value-aufgaben-typ" class="focus-inwards-dark">{{
						aufgabenTyp | labelByAufgabenTyp
					}}</mat-option>
				}
			</mat-select>
			<mat-error data-test-id="aufgabetyp-error">{{ messages.CREATE_AUFGABE_TYPE_MISSING }}</mat-error>
		</mat-form-field>
		@switch (form.value.typ) {
			@case (aufgabenTypen.FINANZSANKTIONSLISTE) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-finanzsanktionsliste" />
			}
			@case (aufgabenTypen.ZERTIFIKAT) {
				<schir-int-client-aufgabe-zertifikat-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-zertifikat" />
			}
			@case (aufgabenTypen.SCHIFFSZERTIFIKAT) {
				<schir-int-client-aufgabe-zertifikat-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-schiffszertifikat" />
			}
			@case (aufgabenTypen.SCHIFFSBRIEF) {
				<schir-int-client-aufgabe-zertifikat-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-schiffsbrief" />
			}
			@case (aufgabenTypen.ALTER_SCHIFFSBRIEF) {
				<schir-int-client-aufgabe-with-static-taetigkeit-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-alter-schiffsbrief" />
			}
			@case (aufgabenTypen.ALTES_ZERTIFIKAT) {
				<schir-int-client-aufgabe-with-static-taetigkeit-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-altes-zertifikat" />
			}
			@case (aufgabenTypen.ZERTIFIKATSAUSZUG) {
				<schir-int-client-aufgabe-zertifikatsauszug-editor
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-zertifikatsauszug" />
			}
			@case (aufgabenTypen.ABSCHRIFT_ZERTIFIKATSAUSZUG) {
				<schir-int-client-aufgabe-versand-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-abschrift-zertifikatsauszug" />
			}
			@case (aufgabenTypen.ALTER_AUSZUG) {
				<schir-int-client-aufgabe-with-static-taetigkeit-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-alter-auszug" />
			}
			@case (aufgabenTypen.HYPOTHEKENBESCHEINIGUNG) {
				<schir-int-client-aufgabe-versand-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-hypothekenbescheinigung" />
			}
			@case (aufgabenTypen.EIGENTUEMERBESCHEINIGUNG) {
				<schir-int-client-aufgabe-versand-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-eigentuemerbescheinigung" />
			}
			@case (aufgabenTypen.LOESCHUNGSBESCHEINIGUNG) {
				<schir-int-client-aufgabe-versand-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-loeschungsbescheinigung" />
			}
			@case (aufgabenTypen.LASTENFREIHEITSBESCHEINIGUNG) {
				<schir-int-client-aufgabe-versand-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-lastenfreiheitsbescheinigung" />
			}
			@case (aufgabenTypen.NAMENSAENDERUNGSBESCHEINIGUNG) {
				<schir-int-client-aufgabe-versand-editor
					[aufgabenTyp]="form.value.typ"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-namensaenderungsbescheinigung" />
			}
			@case (aufgabenTypen.REGISTERABSCHRIFT) {
				<schir-int-client-aufgabe-abschrift-editor data-test-id="aufgabe-registerabschrift" />
			}
			@case (aufgabenTypen.EINTRAGUNGSMITTEILUNG) {
				<schir-int-client-aufgabe-mitteilung-editor
					[register]="register"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					data-test-id="aufgabe-eintragungsmitteilung" />
			}
			@case (aufgabenTypen.MESSBRIEF) {
				<schir-int-client-aufgabe-messbrief-editor
					[register]="register"
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-messbrief" />
			}
			@case (aufgabenTypen.VERMESSUNGSURKUNDE) {
				<schir-int-client-aufgabe-messbrief-editor
					[register]="register"
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-messbrief" />
			}
			@case (aufgabenTypen.SONSTIGE) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-sonstige" />
			}
			@case (aufgabenTypen.ABLAGE) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-ablage" />
			}
			@case (aufgabenTypen.RECHNUNGSSTELLUNG) {
				<schir-int-client-aufgabe-rechnungsstellung-editor data-test-id="aufgabe-rechnungsstellung" />
			}
			@case (aufgabenTypen.KOSTEN) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-kosten" />
			}
			@case (aufgabenTypen.STATISTIK) {
				<schir-int-client-aufgabe-with-notiz-editor [aufgabenTyp]="form.value.typ" />
			}
			@case (aufgabenTypen.HEIMATHAFENVERLEGUNG) {
				<schir-int-client-aufgabe-heimatverlegung-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-heimathafenverlegung" />
			}
			@case (aufgabenTypen.HEIMATORTVERLEGUNG) {
				<schir-int-client-aufgabe-heimatverlegung-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-heimatortverlegung" />
			}
			@case (aufgabenTypen.WIEDERVORLAGE) {
				<schir-int-client-aufgabe-wiedervorlage-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-wiedervorlage" />
			}
			@case (aufgabenTypen.ANSCHREIBEN) {
				<schir-int-client-aufgabe-anschreiben-editor
					[vorlagen]="vorlagen | async"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer"
					[multipleVorlagen]="false"
					data-test-id="aufgabe-anschreiben" />
			}
			@case (aufgabenTypen.LFPR_REGISTERAKTE_ANLEGEN) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-registerakte-anlegen" />
			}
			@case (aufgabenTypen.LFPR_SCHULDTITEL) {
				<schir-int-client-aufgabe-schuldtitel-editor data-test-id="aufgabe-schuldtitel" />
			}
			@case (aufgabenTypen.LFPR_MITTEILUNG) {
				<schir-int-client-aufgabe-lfpr-mitteilung-editor data-test-id="aufgabe-mitteilung" />
			}
			@case (aufgabenTypen.LFPR_STATISTIK) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-statistik" />
			}
			@case (aufgabenTypen.LFPR_VERWEISUNGSVERMERK) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-verweisungsvermerk" />
			}
			@case (aufgabenTypen.LFPR_DB_AKTUALISIEREN) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-db_aktualisieren" />
			}
			@case (aufgabenTypen.LFPR_BLATTABSCHRIFT) {
				<schir-int-client-aufgabe-lfpr-blattabschrift-editor data-test-id="aufgabe-blattabschrift" />
			}
			@case (aufgabenTypen.LFPR_NEGATIVBESCHEINIGUNG) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-negativbescheinigung" />
			}
			@case (aufgabenTypen.LFPR_KOSTEN) {
				<schir-int-client-aufgabe-lfpr-kosten-editor data-test-id="aufgabe-kosten" />
			}
			@case (aufgabenTypen.LFPR_WIEDERVORLAGE) {
				<schir-int-client-aufgabe-wiedervorlage-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-wiedervorlage" />
			}
			@case (aufgabenTypen.LFPR_ERLEDIGT) {
				<schir-int-client-aufgabe-with-notiz-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-erledigt" />
			}
			@case (aufgabenTypen.LFPR_WEGLEGEN) {
				<schir-int-client-aufgabe-lfpr-weglegen-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-weglegen" />
			}
			@case (aufgabenTypen.LFPR_SAMMLUNG) {
				<schir-int-client-aufgabe-lfpr-weglegen-editor
					[aufgabenTyp]="form.value.typ"
					data-test-id="aufgabe-sammlung" />
			}
		}
	</div>

	<mat-dialog-actions>
		<button
			mat-stroked-button
			type="button"
			(click)="onCancel()"
			class="focus-inwards-dark"
			data-test-id="cancel-button">
			Abbrechen
		</button>
		<button
			mat-flat-button
			color="primary"
			(click)="onSave()"
			type="submit"
			class="icon-right focus-inwards-dark"
			[disabled]="hasNoAufgabeTyp() || !isValid()"
			data-test-id="speichern-button">
			Speichern
		</button>
	</mat-dialog-actions>
</form>
